
import { DEFAULT_CATEGORY_ICONS } from './categoryIcons';

export interface Category {
  id: string;
  name: string;
  color: string;
  type: 'receita' | 'despesa';
  icon?: string; // Nome do ícone selecionado
  isDefault?: boolean;
}

export const CATEGORIES: Category[] = [
  // Categorias de Despesa
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d479', name: 'Moradia', color: '#2563EB', type: 'despesa', icon: 'Casa', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d480', name: 'Alimentação', color: '#DC2626', type: 'despesa', icon: 'Restaurante', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d481', name: 'Transporte', color: '#EA580C', type: 'despesa', icon: 'Carro', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d482', name: 'Vestuário', color: '#C026D3', type: 'despesa', icon: 'Roupas', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d483', name: 'Saúde', color: '#16A34A', type: 'despesa', icon: 'Coração', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d484', name: 'Cuidados Pessoais', color: '#F59E0B', type: 'despesa', icon: 'Pincel', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d485', name: 'Educação', color: '#0891B2', type: 'despesa', icon: 'Livro', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d486', name: 'Lazer', color: '#9333EA', type: 'despesa', icon: 'Jogo', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d487', name: 'Viagens', color: '#059669', type: 'despesa', icon: 'Avião', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d488', name: 'Pets', color: '#84CC16', type: 'despesa', icon: 'Pata', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d489', name: 'Presentes', color: '#EF4444', type: 'despesa', icon: 'Presente', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d490', name: 'Investimentos', color: '#7C3AED', type: 'despesa', icon: 'Crescimento', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d491', name: 'Assinaturas', color: '#06B6D4', type: 'despesa', icon: 'Recibo', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d492', name: 'Contas', color: '#6366F1', type: 'despesa', icon: 'Recibo', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d493', name: 'Impostos', color: '#64748B', type: 'despesa', icon: 'Calculadora', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d494', name: 'Manutenção e Reparos', color: '#78716C', type: 'despesa', icon: 'Ferramenta', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d495', name: 'Seguros', color: '#334155', type: 'despesa', icon: 'Escudo', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d496', name: 'Outros', color: '#6B7280', type: 'despesa', icon: 'Configurações', isDefault: true },
  
  // Categorias de Receita
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d497', name: 'Salário', color: '#059669', type: 'receita', icon: 'Carteira', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d498', name: 'Serviços', color: '#0284C7', type: 'receita', icon: 'Maleta', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d499', name: 'Vendas', color: '#7C3AED', type: 'receita', icon: 'Compras', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d500', name: 'Aluguel', color: '#2563EB', type: 'receita', icon: 'Prédio', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d501', name: 'Dividendos', color: '#16A34A', type: 'receita', icon: 'Crescimento', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d502', name: 'Presentes', color: '#EF4444', type: 'receita', icon: 'Presente', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d503', name: 'Investimentos', color: '#9333EA', type: 'receita', icon: 'Porquinho', isDefault: true },
  { id: 'c47ac10b-58cc-4372-a567-0e02b2c3d504', name: 'Outros', color: '#6B7280', type: 'receita', icon: 'Configurações', isDefault: true },
];

export const getCategoryColor = (categoryName: string) => {
  const category = CATEGORIES.find(cat => cat.name === categoryName);
  return category?.color || '#6B7280';
};

export const getCategoryById = (id: string) => {
  return CATEGORIES.find(cat => cat.id === id);
};

export const getCategoryByName = (name: string) => {
  return CATEGORIES.find(cat => cat.name === name);
};

export const getExpenseCategories = () => {
  return CATEGORIES.filter(cat => cat.type === 'despesa');
};

export const getRevenueCategories = () => {
  return CATEGORIES.filter(cat => cat.type === 'receita');
};

export const getCategoriesByType = (type: 'receita' | 'despesa') => {
  return CATEGORIES.filter(cat => cat.type === type);
};

export const getOthersCategoryId = (type: 'receita' | 'despesa') => {
  const othersCategory = CATEGORIES.find(cat => 
    cat.name.includes('Outros') && cat.type === type
  );
  return othersCategory?.id || '';
};
